/**
 * Page canvas behind hero and between sections — matches `html, body`
 * in `src/styles/global.css` and the home page shell.
 */
export const sitePageCanvasBackgroundHex = '#224682'

/** Deep navy used for chrome, body background, and primary text */
export const sitePrimaryHex = '#3398ce'

/** Slightly darker for gradients and footer */
export const sitePrimaryDeepHex = '#163b6e'

/** Sky accent for CTAs and highlights (wash / water) */
export const siteAccentHex = '#38bdf8'

export const siteAccentHexMuted = '#b9ecff'

/** Section wash behind forms (Top Hawk “peach” equivalent) */
export const siteSectionTintHex = '#e8f0fb'

export const siteBodyBackgroundHex = sitePrimaryHex

/** FAQ band — slightly deeper than `sitePrimaryHex` for contrast on blue pages. */
export const siteFaqSectionBackgroundHex = '#152238'

/** Headings on light sections (primary.9, white, #f4f7ff) */
export const siteSectionHeadingHex = '#0a3779'

/** Body copy on light section backgrounds — darkened vs. gray-600 for WCAG AA on `#e8f0fb`. */
export const siteSectionBodyHex = '#374151'

/** Headings on dark navy bands (e.g. `primary.9`) — full white */
export const siteTextOnDarkBandHex = '#ffffff'

/** Body copy on dark navy bands */
export const siteTextOnDarkBandMutedHex = 'rgba(255,255,255,0.92)'

/** Secondary / supporting lines on dark navy bands */
export const siteTextOnDarkBandSubtleHex = 'rgba(255,255,255,0.82)'

/** FAQ inset panel on dark sections — blends with parent instead of flat gray */
export const siteFaqInsetOnDarkBackgroundHex =
   'rgba(255,255,255,0.06)'

/** Hairline around FAQ inset on dark sections */
export const siteFaqInsetOnDarkBorderHex = 'rgba(255,255,255,0.14)'

/** Muted label on dark feature cards */
export const siteFeatureCardMutedLabelHex = 'rgba(255,255,255,0.78)'

/** Secondary body on dark feature cards */
export const siteFeatureCardBodyHex = 'rgba(255,255,255,0.90)'

/** Navy cards (height specs, product lists) */
export const siteFeatureCardBackgroundHex = '#0a3779'

/** Standard large card radius (sections, product cards) */
export const siteSectionCardRadiusPx = 24

/** Standard dark card shadow */
export const siteFeatureCardShadow =
   '0 10px 40px rgba(10, 55, 121, 0.22)'

/** Header bar + mobile nav drawer — frosted navy (matches `AppShell.Header`) */
export const siteNavigationBackdropHex = '#00213fba'

export const primaryCallToActionLabel = 'Get in touch'

export const enquiryResponseExpectation =
   'We read every message and aim to reply within one business day.'

/**
 * Shared section typography — bold but controlled (similar energy to Top Hawk,
 * without oversized hero lines on every block).
 *
 * Use `useMediaQuery('(max-width: 768px)')` for mobile vs desktop.
 */

/** Eyebrow / uppercase section label */
export const siteTypographyEyebrowFontSizeMobile = 15
export const siteTypographyEyebrowFontSizeDesktop = 16

/** Primary section title — route pages and main in-page bands */
export const siteTypographySectionTitlePrimaryFontSizeMobile = 36
export const siteTypographySectionTitlePrimaryFontSizeDesktop = 48

/** Display title — home / large marketing headlines (Services hero, detailing intro) */
export const siteTypographySectionTitleDisplayFontSizeMobile = 38
export const siteTypographySectionTitleDisplayFontSizeDesktop = 56

/** Secondary section title — nested sections (How it works, FAQ in-page, fleet bands) */
export const siteTypographySectionTitleSecondaryFontSizeMobile = 32
export const siteTypographySectionTitleSecondaryFontSizeDesktop = 40

/** Lead and body copy under section titles */
export const siteTypographySectionLeadFontSizeMobile = 18
export const siteTypographySectionLeadFontSizeDesktop = 20

/** Home hero supporting line (below the main headline) */
export const siteTypographyHeroLeadFontSizeMobile = 22
export const siteTypographyHeroLeadFontSizeDesktop = 28

/** Google Maps embed for 42 Studholme Street, Morrinsville */
export const cleanParkMapEmbedSource =
   'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3158.5909141900233!2d175.52929079999998!3d-37.6588206!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d6d094869416f51%3A0x8ebdb2b73704d04e!2s42%20Studholme%20Street%2C%20Morrinsville%203300!5e0!3m2!1sen!2snz!4v1774429125283!5m2!1sen!2snz'
